import { ConfigData } from "../../config";
import { useRadar } from "../../context/RadarContext";
import { HomepageOption, Item, featuredOnly } from "../../model";
import Fadeable from "../Fadeable/Fadeable";
import HeroHeadline from "../HeroHeadline/HeroHeadline";
import QuadrantGrid from "../QuadrantGrid/QuadrantGrid";
import RadarGrid from "../RadarGrid/RadarGrid";
import ReleaseTimeline from "../ReleaseTimeline/ReleaseTimeline";
import SetTitle from "../SetTitle";

type PageIndexProps = {
  leaving: boolean;
  onLeave: () => void;
  /** Items at the selected release. */
  items: Item[];
  /** Items with their full history, used to summarise each release. */
  allItems: Item[];
  config: ConfigData;
  releases: string[];
  selectedRelease?: string;
};

export default function PageIndex({
  leaving,
  onLeave,
  items,
  allItems,
  config,
  releases,
  selectedRelease,
}: PageIndexProps) {
  const { descriptor } = useRadar();

  const numberOfReleases = releases.length;
  const showChart =
    config.homepageContent === HomepageOption.chart ||
    config.homepageContent === HomepageOption.both;
  const showColumns =
    config.homepageContent === HomepageOption.columns ||
    config.homepageContent === HomepageOption.both;

  return (
    <Fadeable leaving={leaving} onLeave={onLeave}>
      <SetTitle title={descriptor.name} standalone />
      <div className="headline-group">
        <HeroHeadline alt={`Version #${numberOfReleases}`}>
          {descriptor.name}
        </HeroHeadline>
      </div>
      {selectedRelease && (
        <ReleaseTimeline
          releases={releases}
          selected={selectedRelease}
          items={allItems}
          radarSlug={descriptor.slug}
        />
      )}
      {showChart && <RadarGrid items={featuredOnly(items)} config={config} />}
      {showColumns && (
        <QuadrantGrid items={featuredOnly(items)} config={config} />
      )}
    </Fadeable>
  );
}
